<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование информации о пользователе') }}
        </v-toolbar-title>
      </v-toolbar>
      <general-error v-if="!!generalError" />
      <v-card-text class="pt-3">
        <ValidationObserver ref="profile" @keydown.native.enter="focusOnBtn('continueBtn')">
          <validatable-text-input
              v-model="profile.email"
              rules="required|email"
              :label="$t('Email пользователя')"
              prepend-icon="alternate_email" />
        </ValidationObserver>
      </v-card-text>
      <v-progress-linear :active="isLoading" color="loader" indeterminate />
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            ref="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      ValidatableTextInput,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            userId: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        profile: {
          email: null,
          userId: null
        }
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        user: state => (state[USER_MANAGEMENT.STATE.CURRENT_USER] || {})
      })
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (!vm.dialogProp.userId) {
          return
        }
        vm.getUserForAdmin()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getUserForAdminAction: USER_MANAGEMENT.ACTIONS.GET_USER_FOR_ADMIN,
        updateUserEmailAction: USER_MANAGEMENT.ACTIONS.UPDATE_USER_EMAIL,
        clearUserForAdminAction: USER_MANAGEMENT.ACTIONS.CLEAR_USER_FOR_ADMIN
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearUserForAdminAction()
          ])
      },
      getUserForAdmin: async function () {
        this.isLoading = true
        try {
          await this.getUserForAdminAction({
            userId: this.dialogProp.userId
          })
          this.profile.email = this.user.email
          this.profile.userId = this.user.userId
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      continueOperation: async function () {
        try {
          const result = await this.$refs.profile.validate()
          if (!result) {
            return
          }
          this.isLoading = true
          await this.updateUserEmailAction(this.profile)
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.isLoading = false
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
          // проверка или сохранение формы неуспешно, остаемся в диалоговом окне
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
